import { Column, Filter } from '@nirvana/shared/dtos/types/shared/filters';
import { GridColumnConfiguration } from '@nirvana/shared/dtos/types/shared/grid';
import { SelectOption } from '../../../ui/gzSelect/types';

export enum ViewType {
  DEFAULT = 0,
  CUSTOM = 1,
}

export enum SectionType {
  DEFAULT = 0,
  SAVED_VIEWS = 1,
  RECENT_VIEWS = 2,
}

export enum SmartViewEvents {
  SMART_VIEW_SELECTED = 'smartViewSelected',
  SMART_VIEW_NAME_UPDATED = 'smartViewNameUpdated',
  SMART_VIEW_DELETED = 'smartViewDeleted',
  SMART_VIEW_CREATED = 'smartViewCreated',
  SMART_VIEW_SAVED = 'smartViewSaved',
  SHOW_SAVE_VIEW_AS_DIALOG = 'showSaveViewAsDialog',
}

export interface BaseSmartViewItemConfiguration<Col = Column, Fil = Filter, Type = ViewType> {
  active?: boolean;
  viewName: string;
  inlineActions?: Array<SelectOption>;
  viewType: Type;
  filters: Array<Fil>;
  displayedColumns: Array<Col>;
  isCompactView: boolean;
  pageSize: number;
  pageNumber?: number;
  columnConfigs?: Array<GridColumnConfiguration>;
}

export interface SmartViewItemConfiguration<Col = Column, Fil = Filter, Type = ViewType>
  extends BaseSmartViewItemConfiguration<Col, Fil, Type> {
  id: string;
}

export interface SmartViewSection<Col = Column, Fil = Filter, Type = ViewType> {
  type: SectionType;
  sectionTitle: string;
  inlineActions: Array<SelectOption>;
  items: Array<SmartViewItemConfiguration<Col, Fil, Type>>;
  smartViewValidators?: Array<any>;
  smartViewMaxInputLength?: number;
  noSpaceEscape?: boolean;
}

export interface GridSmartViewsWebComponentSchema<Col = Column, Fil = Filter, Type = ViewType> {
  sections: Array<SmartViewSection<Col, Fil, Type>>;
  activeViewId: string;
}

export enum SmartViewInlineActions {
  RENAME = 'rename',
  DELETE = 'delete',
  SAVE_AS = 'saveAs',
}

export const DEFAULT_PANEL_TITLE = 'Smart views';
